import { StateDependant, generateDependencies } from './utils';
import { Option } from './types';

export const CLASS_OPEN = 'is-bundle-builder-open';

const getOptionMarkup = (step_id, data:Option) => {
  const template = document.createElement('template');
  template.innerHTML = `
    <style>
      :host {
        width: 100%;
        display: block;
      }

      :root {
        width: 100%;
      }

      customiser-measurement-option {
        width: 100%;
        padding: 0 1.25rem;
      }

      .is-selected {
        border: 1px solid #163021;
        outline: 4px solid #F5F2F0;
        outline-offset: -7px;  
      }

      :host(.is-hidden) {
        display: none;
      }

      .is-disabled {

      }

      .has-error .error-message {
        display: block;
      }

      .error-message {
        color: #c84242;
        padding: .5rem 1rem 0;
        border-radius: .5rem;
        font-size: .875rem;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: .0175rem;
        margin: -.5rem 0 1.25rem;
        display: none;
      }

      .is-error .error-message {
        display: block;
      }

      input {
        font-family: 'TTNorms Font', Helvectica, sans-serif;
        height: 3.125rem;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        border-radius: 1rem;
        border: 1px solid transparent;
        outline: none;
        color: #163021;
        font-size: .875rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: .0175rem;
        transition: all 300ms;
        width: 100%;
      }

      .is-error input,
      .is-error input:focus,
      .is-error input:hover {
        border: 1px solid #c84242;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }
      
      .o-customiser input:first-of-type {
        margin-bottom: 1rem;
      }

      input::placeholder {
        color: rgba(22, 48, 33, 0.30);
      }

      input:hover,
      input:active,
      input:focus {
        border-color: #163021;
      }

      @media only screen and (max-width: 1099px) {
        customiser-measurement-option {
          width: calc(100vw - 2.5rem);
          padding: 0;
        }
      }

      @media only screen and (min-width: 1100px) {

        :host { padding: 0; overflow: visible; }

        customiser-measurement-option {
          padding: 1rem 0 0;
          display: flex;
          flex-direction: row;
          gap: 1rem;
          flex: 1;
          overflow: visible;
          flex-wrap: wrap;
        }

        .o-form__label {
          flex: 1;
        }

        .error-message {
          flex: 0 0 100%;
          padding-left: 0;
        }
       
        input {
          padding-left: 2rem;
          padding-right: 2rem;
          font-size: 1rem;
          letter-spacing: .02rem;
        }
      }

      @media only screen and (min-width: 1750px) {
        input {
          font-size: 1.125rem;
          height: 4rem;
        }
      }


      .o-form__label {
        position: relative;
        display: flex;
        flex-direction: column;
        padding-top: 0;
        transition: all 0.6s;
      }
      .is-label.o-form__label-text {
        position: absolute;
        top: 1rem;
        left: 1.5rem;
        z-index: 1;
        font-family: "TTNorms Font", Helvectica, sans-serif;
        font-weight: 400;
        line-height: 1;
        letter-spacing: 0;
        font-family: "TTNorms Font", Helvectica, sans-serif;
        letter-spacing: 0.0175rem;
        font-weight: 500;
        border-radius: 1rem;
        font-size: 0.875rem;
        line-height: 1.25rem;
        transition: all 0.6s;
        opacity: 0;
      }

      @media only screen and (min-width: 1100px) {
        .o-form__label input:not(:placeholder-shown) + .is-label.o-form__label-text,
        .o-form__label:focus-within .o-form__label-text {
          font-size: 1rem;
          letter-spacing: 0.02rem;
          line-height: 1.5rem;
        }
      }

      @media only screen and (min-width: 1750px) {
        .o-form__label input:not(:placeholder-shown) + .is-label.o-form__label-text,
        .o-form__label:focus-within .o-form__label-text {
          letter-spacing: 0.025rem;
          font-size: 1.25rem;
          line-height: 1.75rem;
        }
      }


      .o-form__label input,
      .o-form__label select,
      .o-form__label textarea {
        transition: all 0.6s;
      }
      .o-form__label:focus-within input,
      .o-form__label:focus-within select,
      .o-form__label:focus-within textarea {
        margin-top: 2.25rem;
      }
      .o-form__label:focus-within .o-form__label-text {
        top: 0.25rem;
        left: 0;
        opacity: 0.5;
      }
      .o-form__label textarea:not(:-moz-placeholder-shown), .o-form__label input:not(:-moz-placeholder-shown) {
        margin-top: 2.25rem;
      }
      .o-form__label textarea:valid,
      .o-form__label select:valid,
      .o-form__label input:valid,
      .o-form__label textarea:not(:placeholder-shown),
      .o-form__label input:not(:placeholder-shown) {
        margin-top: 2.25rem;
      }
      .o-form__label textarea:not(:-moz-placeholder-shown) + .o-form__label-text, .o-form__label input:not(:-moz-placeholder-shown) + .o-form__label-text {
        top: 0.25rem;
        left: 0;
        opacity: 0.5;
      }
        
      .o-form__label textarea:valid + .o-form__label-text,
      .o-form__label select:valid + .o-form__label-text,
      .o-form__label input:valid + .o-form__label-text,
      .o-form__label textarea:not(:placeholder-shown) + .o-form__label-text,
      .o-form__label input:not(:placeholder-shown) + .o-form__label-text {
        top: 0.25rem;
        left: 0;
        opacity: 0.5;
      }


      @media only screen and (min-width: 1100px) {
        .o-form__label:focus-within input,
        .o-form__label:focus-within select,
        .o-form__label:focus-within textarea {
          margin-top: 0;
        }
        .o-form__label:focus-within .o-form__label-text {
          top: -2rem;
        }
        .o-form__label textarea:not(:-moz-placeholder-shown), 
        .o-form__label input:not(:-moz-placeholder-shown) {
          margin-top: 0;
        }
        .o-form__label textarea:valid,
        .o-form__label select:valid,
        .o-form__label input:valid,
        .o-form__label textarea:not(:placeholder-shown),
        .o-form__label input:not(:placeholder-shown) {
          margin-top: 0;
        }
        .o-form__label textarea:not(:-moz-placeholder-shown) + .o-form__label-text, 
        .o-form__label input:not(:-moz-placeholder-shown) + .o-form__label-text {
          top: -2rem;
        }
        .o-form__label textarea:valid + .o-form__label-text,
        .o-form__label select:valid + .o-form__label-text,
        .o-form__label input:valid + .o-form__label-text,
        .o-form__label textarea:not(:placeholder-shown) + .o-form__label-text,
        .o-form__label input:not(:placeholder-shown) + .o-form__label-text {
          top: -2rem;
        }
      }

    </style>

    ${ data.field1_label ? generateInput(data.field1_label, 0) : '' }
    ${ data.field2_label? generateInput(data.field2_label, 1) : '' }
    ${ data.field_validation_required ? generateErrorMessage(data.field_validation_equals_max_width_message) : ''}
  `;
  
  return template;
}

const generateInput = (label, field_index) => {
  return `
  <label class="o-form__label">
    <input placeholder="${label}" name="${label}" field-index="${field_index}" required type="text">
    <div class="o-form__label-text is-label">${label}</div>
  </label>`;
}

const generateErrorMessage = message => {
  return `<p class="error-message">${message}</p>`
}

export class CustomiserMeasurementOption extends StateDependant {

  private data:Option;
  private option_id:string;

  private option_title:string;
  private model_id:string;

  private hide_on_double_configuration:boolean;
  private step_type:string; // may not need this in future
  
  private step_id:string|null = this.getAttribute('step-id');
  private measurement_option:boolean;
  private field1_label:string;
  private field1_required:boolean;
  private field2_label:string;
  private field2_required:boolean;
  private field_validation_required:boolean;
  private field_validation_equals_max_width:boolean;
  private field_validation_equals_max_width_message:string;

  public parentSection:HTMLElement|null;
  public cost:string;

  private isSelected:boolean = false;
  constructor() {
    super();

    const data = this.getAttribute('data');

    if (!this.step_id) {
      console.error('Need to supply a step-id for this option!', this);
      return;
    }
    if (!data) {
      console.error('Need to supply some data for this option!', this);
      return;
    }
    
    this.data = JSON.parse(data);
    this.dependencies = generateDependencies(this.data);
    this.parentSection = this.closest('customiser-section');

    this.option_id = this.data.option_id;
    this.field1_label = this.data.field1_label;
    this.field1_required = this.data.field1_required;
    this.field2_label = this.data.field2_label;
    this.field2_required = this.data.field2_required;

    this.field_validation_required = this.data.field_validation_required;
    this.field_validation_equals_max_width = this.data.field_validation_equals_max_width;
    this.field_validation_equals_max_width_message = this.data.field_validation_equals_max_width_message;

    // const shadowRoot = this.attachShadow({ mode: 'open' });
    const template = getOptionMarkup(this.step_id, this.data);
    this.appendChild(template.content.cloneNode(true));


    this.addEventListener('keyup', this.handleChange);
    this.setState(this.default_state);
  }

  get validationParams() {
    return {
      field1_required: (this.field1_label && this.field1_required) || false,
      field2_required: (this.field2_label && this.field2_required) || false,
      field_validation_equals_max_width: this.field_validation_equals_max_width
    }
  }

  triggerError(isError:boolean) {
    this.classList.toggle('is-error', isError);
  }

  handleChange(e?:Event) {

    const inputEl = e?.target;
    // console.log('change evt from option', inputEl.value);
    const evt = new CustomEvent('measurement_option_change', {
      detail: {
        input_id: inputEl.name,
        value: inputEl.value,
        step_id: this.step_id,
        field_index: parseInt(inputEl.getAttribute('field-index'))
      },
      bubbles: true,
      composed: true
    });

    this.dispatchEvent(evt);
  }

}

if(!customElements.get('customiser-measurement-option')) {
  customElements.define('customiser-measurement-option', CustomiserMeasurementOption);
}